import { render, staticRenderFns } from "./custom-layout.vue?vue&type=template&id=5fb3d14b"
import script from "./custom-layout.vue?vue&type=script&lang=ts"
export * from "./custom-layout.vue?vue&type=script&lang=ts"
import style0 from "./custom-layout.vue?vue&type=style&index=0&id=5fb3d14b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports